import React from 'react';
import { PlayIcon } from 'lucide-react';
interface HeroProps {
  onStartQuiz: () => void;
}
const Hero: React.FC<HeroProps> = ({
  onStartQuiz
}) => {
  return <section className="w-full py-16 px-4 md:py-24 bg-[#0A1020]" data-id="element-84">
      <div className="max-w-5xl mx-auto" data-id="element-85">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-86">
          <div className="flex-1 space-y-6" data-id="element-87">
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight" data-id="element-88">
              Upptäck din optimala sexuella hälsa med vårt quiz
            </h1>
            <p className="text-xl text-gray-300" data-id="element-89">
              Få en personlig plan för bättre prestationsförmåga, uthållighet
              och sexuell hälsa – baserad på forskning, utan pinsamheter.
            </p>
            <ul className="space-y-3" data-id="element-90">
              {['Vetenskapsbackat och tar bara 90 sekunder', 'Personliga rekommendationer baserade på din profil', 'Konkreta tips som faktiskt går att följa'].map((item, index) => <li key={index} className="flex items-start" data-id="element-91">
                  <div className="mr-2 mt-1 text-[#10C96C]" data-id="element-92">✓</div>
                  <span className="text-gray-300" data-id="element-93">{item}</span>
                </li>)}
            </ul>
            <div className="pt-4" data-id="element-94">
              <button onClick={onStartQuiz} className="px-8 py-4 bg-[#0EB7FF] hover:bg-[#0EA7EF] text-black font-semibold rounded-md text-lg flex items-center justify-center transition-all animate-pulse shadow-lg shadow-[#0EB7FF]/30 hover:shadow-[#0EB7FF]/50 relative overflow-hidden" style={{
              animation: 'pulse 2s infinite'
            }} data-id="element-95">
                <span className="absolute inset-0 bg-white opacity-20 animate-ping rounded-md" style={{
                animation: 'ping 2s cubic-bezier(0, 0, 0.2, 1) infinite'
              }} data-id="element-96"></span>
                <PlayIcon className="w-5 h-5 mr-2" data-id="element-97" />
                Starta quiz
              </button>
              <p className="text-sm text-gray-400 mt-2" data-id="element-98">
                Upptäck hur du kan förbättra din sexuella hälsa
              </p>
            </div>
          </div>
          <div className="flex-1 mt-8 md:mt-0" data-id="element-99">
            <div className="relative rounded-xl overflow-hidden" data-id="element-100">
              <img src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" alt="Man working out at the gym" className="w-full h-auto object-cover rounded-xl" data-id="element-101" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1020] to-transparent opacity-70" data-id="element-102"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;